export default "__VITE_ASSET__59abbbc3__"